export default __webpack_public_path__ + "static/media/modal_ColorPick.bbde629e.png";